import { browser } from '$app/environment';
import { CartItemFrom } from '$lib/models/cart-item';
import { writable, type Writable } from 'svelte/store';

export const trialModalFrom = writable<CartItemFrom>(CartItemFrom.UNKNOWN);
export const trialModalPremium = writable<boolean>(true);
export const trialModalAnnual = writable<boolean>(true);
export const showTrialModal = writable(false);